import { dbuiV1GetNotablesSummaryOptions } from '@antimatterhq/asl-api-ts-v1';
import { useSuspenseQuery } from '@antimatterhq/ui/hooks/queries/useSuspenseQuery';
import { useValueWithSuspense } from '@antimatterhq/ui/hooks/suspense/useValueWithSuspense';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { defaultOptions } from '@/utils/query';

export const useGetNotablesSummary = () => {
  const workspaceContext = useWorkspace();
  const warehouseLocationContext = useWarehouseLocation();
  const workspace = useValueWithSuspense(workspaceContext.workspace);
  const selectedWarehouse = useValueWithSuspense(
    warehouseLocationContext.selectedWarehouse,
  );

  return useSuspenseQuery({
    ...dbuiV1GetNotablesSummaryOptions({
      ...defaultOptions(),
      path: { workspace },
      query: { warehouse: selectedWarehouse?.id || '' },
    }),
  });
};
